import Service, { IService } from "@/model/Service/Service"

export const sansCriteria = '1013'

const getIsSansOption = (service: IService) => {
    if (service instanceof Service) {
        if (service.getServiceContent()?.getCriteriasSet().has(sansCriteria)) return true
        return false
    } else {
        throw new TypeError("can only handle Services")
    }
}

export default getIsSansOption